<template>
	<div class="fullwidth bg_main" >

		<div class="fullwidth padding5 ">
			<block v-for="(item, index) in goodsList" :key="index">
				
				<!-- 大图 -->
				<div v-if="isBigImg" :style="'width:'+imgWidth+';'"
					class=" padding5  center inline" hover-class="uni-list-cell-hover">
					<div class=" fullwidth inline bg_white ">

						<div @click="toDetail(item)" class=" fullwidth overhide "
							:style="'padding-bottom:100%;background-image:url('+item.imgArr[0]+');background-position:center center;background-size:100% auto;background-repeat:no-repeat;background-color:#ddd;' "
							mode="widthFix"></div>

						<div class="padding5  fullwidth">
							<div   class="flex_row padding0">
								<div class="size4 ellips">{{ item.name }}</div>
								<span class="size4 color_red">￥{{ item.minPrice==item.maxPrice?item.minPrice:(item.minPrice+"-"+item.maxPrice)}}</span>
							</div>
							<div class="flex_row padding0 ">

								<div  class="inline middle  size4 color2">
									余{{ item.store }}</div>

								<div class="height40 nowrap flex_row_s padding0 autowidth">
									<div v-if="item.currOrderCount>0"
										@click="changeCount('-',item,'')"
										class="uni-icon uni-icon-minus-filled   middle inline color_orange  bold sizeb">
									</div>
									<div v-if="item.currOrderCount>0"
										class="radius5 middle inline  border color_red width40 height40 marginl5 marginr5 lineh40 center">
										{{item.currOrderCount?item.currOrderCount:0}}
									</div>
									<div @click="changeCount('+',item,'')"
										class="uni-icon uni-icon-plus-filled  middle inline color_green  bold sizeb ">
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>

				<!-- 小图列表 -->
				<div v-else class="marginb10 bg_white" hover-class="uni-list-cell-hover">
					<div class="flex_row">

						<img @click="toDetail(item)" class=" width200r height200r minwidth200r" mode="aspectFill"
							:src="item.imgArr[0]" />

						<div class="marginl10 fullwidth">
							<div @click="toDetail(item)" class="flex_row padding0">
								<div class="size3 ellips">{{ item.name }}</div>
								<span class="size3 color_red">￥{{ item.goodsSpecList[0].price}}</span>
							</div>
							<div class="flex_row padding0 margint10">

								<div @click="toDetail(item)" class="inline middle  size4 color2">
									余{{ item.goodsSpecList[0].store }}
								</div>

								<div class="height50 nowrap flex_row_s padding0 autowidth">
									<div v-if="item.goodsSpecList[0].currOrderCount>0"
										@click="changeCount('-',item,'')"
										class="uni-icon uni-icon-minus-filled   middle inline color_orange  bold sizeb ">
									</div>
									<div v-if="item.goodsSpecList[0].currOrderCount>0"
										class="radius5 middle inline  border color_red width40 height40 margin5 lineh40 center">
										{{item.goodsSpecList[0].currOrderCount?item.goodsSpecList[0].currOrderCount:0}}
									</div>
									<div @click="changeCount('+',item,'')"
										class="uni-icon uni-icon-plus-filled  middle inline color_green  bold sizeb ">
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>

			</block>
		</div>
		<uni-load-more :status="status" :icon-size="16" />




		<!-- 规格弹窗 -->
		<uni-popup ref="spec_popup" scrollable="true" background-color="#fff" @change="popChange">
			<scroll-view @touchmove.stop scroll-y="true" 
				class="height50vh overscroll padding10 left h5maxwidth automargin" 
				:class="{ 'width250': popType === 'left' || popType === 'right' }">
				<div>
					<img class="width250r autoheight" mode="widthFix" :src="selectedGoods.img" />
				</div>
				<div class="size3 marginb10 color_blue">{{selectedGoods.name}}</div>

				<div class="fullwidth ">
					<block v-for="(item, index) in selectedGoods.goodsSpecList" :key="index">
						<div class="marginb20 padding0 border">
							<div class="fullwidth bg_eee padding10">{{item.name}}</div>
							<div class="flex_row padding10">
								<div>
									<div class="inline">￥{{item.price}}</div>
									<div class="inline paddingl10">余{{item.store}}</div>
								</div>

								<div class="right">
									<div v-if="item.currOrderCount>0" @click="changeCount('-',selectedGoods,item.id)"
										class="uni-icon uni-icon-minus-filled   middle inline color_orange  bold sizeb">
									</div>
									<div v-if="item.currOrderCount>0"
										class="radius5 middle inline  border color_red width40 height40 margin5 lineh40 center">
										{{item.currOrderCount?item.currOrderCount:0}}
									</div>
									<div @click="changeCount('+',selectedGoods,item.id)"
										class="uni-icon uni-icon-plus-filled  middle inline color_green  bold sizeb ">
									</div>
								</div>
							</div>


						</div>
					</block>
				</div>
				<div class="height50"></div>
			</scroll-view>
		</uni-popup>

		<!-- 普通弹窗 -->
		<uni-popup ref="common_popup" background-color="none" @change="popChange">
			<div v-if="popEvent=='topay'"
				class="relative width600r maxwidth400 popup-content padding10 left bg_white shadow8  radius20r"
				:class="{ 'popup-height': popType === 'left' || popType === 'right' }">

				<div class="center size4r padding10">
					<img :src="dw_huli" class="inline width100r height100r middle" mode="aspectFit" />
					手机付款码支付
				</div>
				<div class="padding10">
					<div>{{selectedGoods.name}}</div>
					<div>￥{{selectedGoods.goodsSpecList[0].price}}X1</div>
					<div>合计￥{{selectedGoods.goodsSpecList[0].price}}</div>
				</div>
				<div class="flex_center margint40r bordert padding10 ">
					<div @click="showSaomaNote()"
						class="flex1 maxwidth150  paddingt10 paddingb10 center border_grey radius10">
						<div class="inline middel color_red">付款码支付</div>
					</div>
				</div>

			</div>
		</uni-popup>


	</div>
</template>

<script>

	/**
	 * Vuex 是专门为 Vue.js 设计的状态管理库
	 * 在vuex里面，state里面是存放数据的（类似于vue里面的data），
	 * mutations里面存放的是各种函数方法，用来改变state里面的数据的方法
	 */
	import {
		mapMutations,
		mapState
	} from 'vuex'
	// import uniLoadMore from '@/components/uni-load-more/uni-load-more.vue';
	//
	//var app = getApp();
import uniPopup from '@/components/uni-popup/uni-popup.vue';

	export default {
		components: {
			// uniLoadMore
			uniPopup
		},
		data() {
			return {
				paddingBottom: "100%",
				popEvent: "",
				popType: "center",
				dw_huli: window.$config.userHost + "/file/image/dw04.png",

				isBigImg: true,
				imgWidth: "50%",
				goodsList: [],
				page: 1,
				totalPage: 0,
				status: '',

				selectedGoods: {}
			};
		},
		onShareAppMessage() {
			return {
				title: '欢迎体验',
				path: '/pages/goods/list/list'
			}
		},
		onNavigationBarButtonTap(e) {
			this.$router.push({ path: '/' }); 
		},
		created() {

			var that = this;
			window.$utils.uniapi.setNavigationBarTitle({ title:"商品" });
			
			//界面适配
			that.changeListMode();
			window.$utils.uniapi.onWindowResize(function() {
				that.changeListMode();
			});


			this.page = 1;
			this.getList();

			//app.getToken();
			
		},

		mounted() {
			console.log("onShow");
			this.fromCart();
		},
		onPullDownRefresh() {
			this.page = 1;
			this.getList();
			window.$utils.uniapi.stopPullDownRefresh();
		},
		onReachBottom() {
			this.status = this.page >= this.totalPage ? "nomore" : 'more';
			if (this.page < this.totalPage) {
				this.page++;
				this.getList();
			}
		},
		methods: {


			/**
			 * 从购物车采集订购数据
			 * 商品数据获取完成后，初始购物车
			 */
			fromCart() {
				var that = this;

				this.cartGoodsList = window.$utils.uniapi.getStorageSync('cartGoodsList') || [];

				//初始商品选购数量
				var goodsList = this.goodsList;
				for (var g = 0; g < goodsList.length; g++) {
					var isInCart = false; //
					//在购物车中的按购物车数据
					for (var c = 0; c < this.cartGoodsList.length; c++) {
						if (goodsList[g].id == this.cartGoodsList[c].id) {
							//商品当前订购数量
							goodsList[g].currOrderCount = this.cartGoodsList[c].currOrderCount;
							//进一步赋值规格订购数量
							for(var cs = 0; cs < this.cartGoodsList[c].goodsSpecList.length; cs++){
								for (var gs = 0; gs < goodsList[g].goodsSpecList.length; gs++) {
									if(goodsList[g].goodsSpecList[gs].id==this.cartGoodsList[c].goodsSpecList[cs].id){
										goodsList[g].goodsSpecList[gs].currOrderCount=this.cartGoodsList[c].goodsSpecList[cs].currOrderCount;
									}
								}
							}
							isInCart = true;break;
						}
					}
					if (!isInCart) {
						//清空数量
						goodsList[g].currOrderCount = 0;
						for (var gs = 0; gs < goodsList[g].goodsSpecList.length; gs++) {
							goodsList[g].goodsSpecList[gs].currOrderCount = 0;
						}
					}
				}

				this.goodsList = goodsList;
				console.log(this.goodsList);
				this.$forceUpdate();
			},

			//================
			showPop() {
				this.$refs.common_popup.open(this.popType);
			},
			closePop() {
				try {
					this.$refs.common_popup.close();
				} catch (e) {}
				//this.audioStop();
			},
			popChange(e) {
				console.log(e);
			},
			//============
			changeListMode() {


				var that = this;
				var sys = window.$utils.uniapi.getSystemInfoSync();
				var windowWidth = sys.windowWidth;
				var windowHeight = sys.windowHeight;
				// alert(windowWidth);
				// if(windowWidth>=768){
				// 	that.isBigImg=true;
				// 	that.paddingBottom=windowWidth>windowHeight?"70%":"100%";
				// }else{
				// 	that.isBigImg=false;
				// }

				if (windowWidth < 600) {
					this.imgWidth = "50%";
				} else if (windowWidth < 900) {
					this.imgWidth = "33.33%";
				} else if (windowWidth < 1200) {
					this.imgWidth = "33.33%";//"25%";
				} else if (windowWidth < 1500) {
					this.imgWidth = "33.33%";//"25%";//20%
				} else {
					this.imgWidth = "33.33%";//"25%";//16.66%";
				}
			},
			createOrder() {
				console.log("createOrder");

			},


			/**
			 * 数量增减
			 */
			changeCount(action, goods, specId) {
				var that = this;
				
				var goodsId = goods.id;
				if (goods.goodsSpecList.length == 1) {
					specId = goods.goodsSpecList[0].id;
				}
				console.log("changeCount", action, specId, goodsId);
				if (!!specId == false) {
					this.selectedGoods = goods;
					this.$refs.spec_popup.open("bottom");
					return;
				}
				
				
				
				//更新数据
				var goodsObj = null;
				if (this.selectedPackage && goodsId == this.selectedPackage.id) {
					console.log("适用单一商品");
					goodsObj = this.changeCountForObj(action, specId);
				} else {
					console.log("适用商品List");
					goodsObj = this.changeCountForList(action, goodsId, specId);
				}

				if(typeof goodsObj=='string'){
					window.$utils.uniapi.showToast({ title:goodsObj,icon:"none" });return;
				}

				//加入购物车
				this.addCart(goodsObj); //.updateCartGoodsList();


				//更新购物车
				//that.updateCart(goodsId);
				//that.updateCartGoodsList();

			},
			/**
			 * 更新单个商品数量（选定的包装数量）
			 */
			changeCountForObj(action, specId) {

				var goodsCount = 0; //单品订购数量
				var goodsObj = this.data.selectedPackage;
				for (var p = 0; p < goodsObj.goodsSpecList.length; p++) {
					if (goodsObj.goodsSpecList[p].id == specId) {

						//更新数量
						if (action == "+") {
							goodsObj.goodsSpecList[p].currOrderCount++;
						} else {
							goodsObj.goodsSpecList[p].currOrderCount--;
							if (goodsObj.goodsSpecList[p].currOrderCount < 0) {
								goodsObj.goodsSpecList[p].currOrderCount = 0;
							}
						}

						//更新选品
						//goodsObj=selectedPackage;
						//console.log("==============2",action,specId,goodsObj);
					}

					//统计单品
					goodsCount += goodsObj.goodsSpecList[p].currOrderCount;
				}

				//统计多规格订购数量
				//var totalSpecCount=goodsList[i].goodsSpecList);
				//goodsObj.currOrderCount=goodsCount;
				goodsObj.currOrderCount = goodsCount;

				//设置价格
				goodsObj = this.setPackagePrice(goodsObj);

				this.setData({
					selectedPackage: goodsObj
				});
				return goodsObj;
			},

			/**
			 * 更新list数量
			 * @param {} action 
			 * @param {*} goodsId 
			 * @param {*} specId 
			 */
			changeCountForList(action, goodsId, specId) {
				if (!!specId == false) {
					console.log("缺少规格");
					return;
				}
				var goodsObj = {};
				var goodsList = this.goodsList;
				for (var i = 0; i < goodsList.length; i++) {
					if (goodsList[i].id == goodsId) {

						var goodsCount = 0; //单品订购数量
						for (var p = 0; p < goodsList[i].goodsSpecList.length; p++) {
							if (goodsList[i].goodsSpecList[p].id == specId) {
								
								//检查库存
								if(action == "+" && goodsList[i].storeShare==0 
									&& goodsList[i].goodsSpecList[p].store < goodsList[i].goodsSpecList[p].currOrderCount+1
									){
									return "超过库存";
								}
								
								if (typeof goodsList[i].goodsSpecList[p].currOrderCount == 'undefined') {
									goodsList[i].goodsSpecList[p].currOrderCount = 0;
								}
								//更新数量
								if (action == "+") {
									goodsList[i].goodsSpecList[p].currOrderCount++;
								} else {
									goodsList[i].goodsSpecList[p].currOrderCount--;
									if (goodsList[i].goodsSpecList[p].currOrderCount < 0) {
										goodsList[i].goodsSpecList[p].currOrderCount = 0;
									}
								}
								
								
								
								//更新选品
								goodsObj = goodsList[i];
							}

							//统计单品
							goodsCount += goodsList[i].goodsSpecList[p].currOrderCount;
						}

						//统计多规格订购数量
						//var totalSpecCount=goodsList[i].goodsSpecList);
						goodsObj.currOrderCount = goodsCount;
						goodsList[i].currOrderCount = goodsCount;



					}
				}
				this.goodsList = goodsList;
				this.selectedGoods = goodsObj;

				return goodsObj;
			},


			addCart(goodsObject) {
				try{

					var totalCount = 0;
					var totalAmount = 0;

					var cartGoodsList = window.$utils.uniapi.getStorageSync('cartGoodsList') || [];
					console.log('cartGoodsList构造函数需为Array:', cartGoodsList.constructor.name)
					// if(cartGoodsList.constructor.name=='Object'){cartGoodsList=[];}

					var index = -1; //商品在购物车中的序号
					for (var i = 0; i < cartGoodsList.length; i++) {
						if (cartGoodsList[i].id == goodsObject.id) {
							index = i;
							break;
						}
					}
					console.log("更新购物车数据", cartGoodsList);
					if (index > -1) {
						//置换数据
						if (goodsObject.currOrderCount > 0) {
							cartGoodsList[index] = goodsObject;
						} else {
							//移除
							cartGoodsList.splice(i, 1 ); //arrayObj.splice(deletePos,deleteCount); //删除从指定位置deletePos开始的指定数量deleteCount的元素，数组形式返回所移除的元素
						}
					} else {
						cartGoodsList.push(goodsObject);
					}

					//更新统计
					for (var i = 0; i < cartGoodsList.length; i++) {
						console.log('cartGoodsList[i].goodsSpecList ', cartGoodsList[i].goodsSpecList);
						for (var p = 0; p < cartGoodsList[i].goodsSpecList.length; p++) {
							if (cartGoodsList[i].goodsSpecList[p].currOrderCount <= 0) continue;
							totalCount += cartGoodsList[i].goodsSpecList[p].currOrderCount;
							totalAmount += cartGoodsList[i].goodsSpecList[p].currOrderCount * cartGoodsList[i].goodsSpecList[p]
								.price;
						}
					}

					window.$utils.uniapi.setStorageSync('cartGoodsList', cartGoodsList);


					//提示
					// if (totalCount > 0) {
					// 	window.$utils.uniapi.setTabBarBadge({ index: 2, text: '' + totalCount });
					// } else {
					// 	window.$utils.uniapi.removeTabBarBadge({ index: 2 });
					// }
					// window.$store.state.cartGoodsCount=totalCount;
					window.$store.commit('setCartGoodsCount', totalCount)

					this.totalCount = totalCount;
					this.totalAmount = totalAmount.toFixed(2);
				}catch(error){
					console.log(error);
				}
				
			},




			getList() {
				var that = this;
				this.status = "loading";
				this.$axios.request({
						url: window.$config.url.getGoodsList,
						data: {
							page: this.page,
							categoryIndex: this.categoryIndex
						}
					})
					.then(res => {
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							// this.chineseverifyImg=res.data.img;
							// this.onceStr=res.data.onceStr;
							console.log("=========================");
							let list = res.data.list;
							list = that.fitData(list);
							this.goodsList = this.page == 1 ? list : this.goodsList.concat(list);
							this.totalPage = res.data.totalPage;
							this.totalRows = res.data.totalRows;
							this.status = this.page >= this.totalPage ? "nomore" : 'more';
							this.fromCart();
						} else if (!!res.msg == true) {
							window.$utils.uniapi.showToast({
								title: res.msg,
								icon: "none"
							});
						} else {
							window.$utils.uniapi.showToast({
								title: "不成功",
								icon: "none"
							});
						}
					});

			},
			fitData(list) {
				for (var i = 0; i < list.length; i++) {
					list[i].contentDisplay = window.$utils.delHtmlTag(list[i].content);
				}
				return list;
			},
			toDetail: function(item) {
				console.log(item);
				
				// this.selectedGoods = item;
				// this.popEvent = "topay";
				// this.showPop();
				
				this.$router.push({path:"/goods_detail",query:{ id:item.id }});
			},
			showSaomaNote() {
				this.saveOrder();
				window.$utils.uniapi.showToast({
					title: "请将付款码对准摄像头",
					icon: "none"
				});

			},
			saveOrder() {
				var that = this;
				// if(!this.isReaded){
				// 	window.$utils.uniapi.showToast({ title:"请阅读并同意协议",icon:"none" });return;
				// }
				var specId = this.selectedGoods.goodsSpecList.length == 1 ? this.selectedGoods.goodsSpecList[0].id : 0;
				if (specId == 0) {
					window.$utils.uniapi.showToast({
						title: "请选择spec",
						icon: "none"
					});
					return;
				}
				var goodsListJson = [{
					id: this.selectedGoods.id,
					goodsSpecList: [{
						id: specId,
						currOrderCount: 1
					}]
				}];
				//var note=this.goods.name;

				var contactId = 0;
				this.$axios.request({
						url: window.$config.url.saveOrder,
						data: {
							contactId: contactId, //note:note,
							goodsListJson: JSON.stringify(goodsListJson)
						}
					})
					.then(res => {
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							if ('Uldbavb42s4rDi' == that.user.id) {
								that.scanCode(res.data.id);
								return;
							}
							that.toPay(res.data.id);
						} else if (!!res.msg == true) {
							window.$utils.uniapi.showToast({
								title: res.msg,
								icon: "none"
							});
						} else {
							window.$utils.uniapi.showToast({
								title: "不成功",
								icon: "none"
							});
						}
					});



			},
			scanCode(orderId) {
				var that = this;
				that.payByAuthCode(orderId, '');
				// 允许从相机扫码
				// window.$utils.uniapi.scanCode({
				// 	onlyFromCamera: true,
				// 	success: function (res) {
				// 		console.log('条码类型：' + res.scanType);
				// 		console.log('条码内容：' + res.result);
				// 		that.payByAuthCode(orderId,res.result);
				// 	}
				// });
			},
			payByAuthCode(orderId, payAuthCode) {
				payAuthCode = "134697069318947944";
				//获取支付参数
				this.$axios.request({
						url: window.$config.url.payByAuthCode,
						data: {
							orderId: orderId,
							payAuthCode: payAuthCode,
							payChannel: 4 //微信付款码
						}
					})
					.then(res => {
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							console.log("支付成功");
							window.$utils.uniapi.showToast({
								title: "成功",
								icon: "none"
							});
						} else if (!!res.code == true && res.code == window.$config.resCode.PAY_IS_DOING) {
							console.log("正在支付中");
							that.getPayState(orderId);
						} else if (!!res.msg == true) {
							window.$utils.uniapi.showToast({
								title: res.msg,
								icon: "none"
							});
						} else {
							window.$utils.uniapi.showToast({
								title: "不成功",
								icon: "none"
							});
						}
					});
			},
			getPayState(orderId) {

			},
		}
	};
</script>

<style scoped>
	.banner {
		height: 180px;
		overflow: hidden;
		position: relative;
		background-color: #ccc;
	}

	.banner-img {
		width: 100%;
	}

	.banner-title {
		max-height: 42px;
		overflow: hidden;
		position: absolute;
		left: 15px;
		bottom: 15px;
		width: 90%;
		font-size: 16px;
		font-weight: 400;
		line-height: 21px;
		color: white;
		z-index: 11;
	}



	.uni-media-list-body {
		height: auto;
		justify-content: space-around;
	}

	.uni-media-list-text-top {
		overflow: hidden;
	}

	.uni-media-list-text-bottom {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
</style>


// WEBPACK FOOTER //
// src/views/tabbar/goods/index.vue